import React, { Fragment } from 'react';
import { LeftMenuUser } from '../LeftMenuUser';
import { CurrentUserLimits } from '../../../../slices/current-user/current-user.state';
import {
    PRACTICE_OWNER_TYPES,
    PRACTICE_STATUS_ENUM,
} from '../../../../utils/constants';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { FeatureFlag } from '../../../../containers/FeatureFlags/FeatureFlag';
import { FeatureFlagsEnum } from '../../../../containers/FeatureFlags/FeatureFlags.enum';
import { DataRequestMenuItem } from '../items/DataRequestMenuItem';
import { HomeMenuItem } from '../items/HomeMenuItem';
import { MyAccountMenuItem } from '../items/MyAccountMenuItem';
import { NotificationSettingsMenuItem } from '../items/NotificationSettingsMenuItem';
import { MyTeamMembersMenuItem } from '../items/MyTeamMembersMenuItem';
import { MyPracticesMenuItem } from '../items/MyPracticesMenuItem';
import { MyGroupsMenuItem } from '../items/MyGroupsMenuItem';
import { MyReferralHubMenuItem } from '../items/MyReferralHubMenuItem';
import { MyEngagementsMenuItem } from '../items/MyEngagementsMenuItem';
import { MyDealsMenuItem } from '../items/MyDealsMenuItem';
import { ObservingDealsMenuItem } from '../items/ObservingDealsMenuItem';

const HEADING = 'app-sidebar__heading vertical-nav-menu';
const HEADING_CUSTOM = 'app-sidebar__heading vertical-nav-menu custom';
const HEADING_CUSTOM_SPACED = 'app-sidebar__heading vertical-nav-menu custom ';

export interface PracticeOwnerMenuProps {
    user: LeftMenuUser;
    limits: CurrentUserLimits;
}

export const PracticeOwnerMenu = (props: PracticeOwnerMenuProps) => {
    const { user, limits } = props;
    const practices = user.practices || [];
    const approvedPractices = practices.filter(
        (p) => p.status === PRACTICE_STATUS_ENUM.Approved
    );
    const isAnyPracticeApproved = approvedPractices.length > 0;
    const isAspiringOwner =
        user.practiceOwnerType === PRACTICE_OWNER_TYPES.ASPIRING;
    const hasPaidSubscription = !!(
        limits &&
        limits.doesSupportSubscriptions &&
        limits.hasPaidSubscription
    );
    const isMarketplaceBroker = !!user.isMarketplaceBroker;
    const engagements = user.engagements || [];
    const hasSellerEngagement =
        practices.some((p) => p.isInEngagement) &&
        engagements.some((e) => e.party === TimelineParty.Seller);

    return (
        <Fragment>
            <div id="left-menu" />
            <div>
                <HomeMenuItem
                    className={isAnyPracticeApproved ? HEADING : HEADING_CUSTOM}
                />
                <MyAccountMenuItem />
                <FeatureFlag flag={FeatureFlagsEnum.FF_Notifications}>
                    <NotificationSettingsMenuItem />
                </FeatureFlag>
                {hasPaidSubscription && (
                    <MyTeamMembersMenuItem
                        className={
                            isAnyPracticeApproved ? HEADING : HEADING_CUSTOM
                        }
                    />
                )}
                <MyPracticesMenuItem
                    practices={approvedPractices}
                    headingClassName={
                        !isAspiringOwner ? HEADING : HEADING_CUSTOM_SPACED
                    }
                />
                <MyGroupsMenuItem
                    summary={user}
                    limits={limits}
                    headingClassName={
                        isAnyPracticeApproved && !isAspiringOwner
                            ? HEADING
                            : HEADING_CUSTOM_SPACED
                    }
                    headingTo="/admin-my-groups"
                />
                <MyReferralHubMenuItem
                    className={
                        isAnyPracticeApproved || user.isReferral
                            ? HEADING
                            : HEADING_CUSTOM
                    }
                />
                {user.isOtherDataRequestProjectAvailable && (
                    <DataRequestMenuItem />
                )}
                {hasSellerEngagement && (
                    <MyEngagementsMenuItem engagements={engagements} />
                )}
            </div>

            {isMarketplaceBroker &&
                engagements.some((e) => e.party === TimelineParty.Broker) && (
                    <MyDealsMenuItem engagements={engagements} />
                )}
            {isMarketplaceBroker &&
                engagements.some((e) => e.party === TimelineParty.Observer) && (
                    <ObservingDealsMenuItem engagements={engagements} />
                )}
        </Fragment>
    );
};
